import { take, call, all, select, put } from 'redux-saga/effects'
import { apiSaga } from './sagas'
import { loadOrderByDate, loadDeliveriesForLocation } from '../../api/api'
import { loadOrderSuccess, loadOrderFailure } from './orderDetail'
import {
  loadDeliveryScheduleSuccess,
  loadDeliveryScheduleFailure,
} from './delivery'
import { format } from 'date-fns'
import { selectIsAuthenticated } from './selectors'

// ------------------------------------
// Action Types & Creators
// ------------------------------------
export const LOAD_TODAY = 'foodsby/home/LOAD_TODAY'
export const CHANGE_SELECTED_DAY = 'foodsby/home/CHANGE_SELECTED_DAY'
export const CHANGE_SELECTED_DAY_SUCCESS =
  'foodsby/home/CHANGE_SELECTED_DAY_SUCCESS'
export const CHANGE_SELECTED_DAY_LOGIN_OR_JOIN =
  'foodsby/home/CHANGE_SELECTED_DAY_LOGIN_OR_JOIN'
export const CHANGE_SELECTED_DAY_FAILURE =
  'foodsby/home/CHANGE_SELECTED_DAY_FAILURE'
export const SHOW_LOGIN_OR_JOIN = 'foodsby/home/SHOW_LOGIN_OR_JOIN'

export const changeSelectedDay = (selectedDate, locationId) => {
  return {
    type: CHANGE_SELECTED_DAY,
    payload: { selectedDate, locationId },
  }
}

export const changeSelectedDaySuccess = () => {
  return {
    type: CHANGE_SELECTED_DAY_SUCCESS,
  }
}

export const changeSelectedDayFailure = error => {
  return {
    type: CHANGE_SELECTED_DAY_FAILURE,
    error,
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [CHANGE_SELECTED_DAY]: (state, action) => {
    return {
      ...state,
      selectedDate: action.payload.selectedDate,
      locationId: action.payload.locationId,
      loadingNewDay: true,
    }
  },
  [CHANGE_SELECTED_DAY_LOGIN_OR_JOIN]: (state, action) => {
    return {
      ...state,
      loadingNewDay: false,
    }
  },
  [CHANGE_SELECTED_DAY_SUCCESS]: (state, action) => {
    return {
      ...state,
      loadingNewDay: false,
    }
  },
  [CHANGE_SELECTED_DAY_FAILURE]: (state, action) => {
    return {
      ...state,
      loadingNewDay: false,
      error: action.payload,
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  todaysDate: format(new Date(), 'YYYYMMDD'),
  selectedDate: format(new Date(), 'YYYYMMDD'),
}

export default function home(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------
export function* watchChangeSelectedDay() {
  while (true) {
    const {
      payload: { selectedDate, locationId },
    } = yield take(CHANGE_SELECTED_DAY)

    try {
      const isAuthenticated = yield select(selectIsAuthenticated)
      if (isAuthenticated) {
        yield all([
          call(
            apiSaga,
            loadOrderByDate,
            [selectedDate, locationId],
            loadOrderSuccess,
            loadOrderFailure,
          ),
          call(
            apiSaga,
            loadDeliveriesForLocation,
            [locationId, selectedDate],
            loadDeliveryScheduleSuccess,
            loadDeliveryScheduleFailure,
          ),
        ])
      } else {
        yield call(
          apiSaga,
          loadDeliveriesForLocation,
          [locationId, selectedDate],
          loadDeliveryScheduleSuccess,
          loadDeliveryScheduleFailure,
        )
      }
      yield put(changeSelectedDaySuccess())
    } catch (error) {
      yield put(changeSelectedDayFailure(error))
    }
  }
}
